import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { useLocation } from 'react-router-dom';
import {
  FormWrapper,
  Title,
  ButtonLogin,
  FieldWrapper,
} from './styled';
import { COLORS } from '@app/src/ui';
import { renderInput } from '@app/src/common/Input/renderInput';
import * as validate from '@app/src/utils/validations';
import { fetchResetPassword } from '@app/src/common/session';
import { isClientEnv } from '@app/src/utils/validations';

const isClient = isClientEnv();

interface Props {
  handleSubmit?: Function;
  hash: string;
}


const equalToPassword = (value, allValues) =>
  value !== allValues.password ?
    'Los campos son diferentes' :
    null


export const Form: React.FC<Props> = ({ handleSubmit }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.session.password.isFetchingReset);
  const location = useLocation();
  const [hash, setHash] = useState(null);
  let query = null;

  useEffect(() => {
    if (isClient && 'URLSearchParams' in window) {
      query = new URLSearchParams(location.search);
      setHash(query.get('hash'));
    }
  }, []);

  const handleClickSubmit = (data): void => {
    const sendData = {
      ...data,
      hash
    };
    dispatch(fetchResetPassword(sendData));
  };

  return (
    <React.Fragment>
      <FormWrapper>
        <Title>Ingresa tu nueva contraseña</Title>
        <FieldWrapper>
          <Field
            autocomplete
            name="password"
            type="password"
            placeholder="Usa 8 caracteres alfanúmericos"
            maxLength={16}
            component={renderInput}
            validate={[validate.required, validate.minLength8, validate.minimeOneNumber, validate.minimeOneLetter]}
          />
        </FieldWrapper>
        <FieldWrapper>
          <Field
            autocomplete
            name="confirmPassword"
            type="password"
            placeholder="Usa 8 caracteres alfanúmericos"
            maxLength={16}
            component={renderInput}
            validate={[validate.required, equalToPassword, validate.minLength8, validate.minimeOneNumber, validate.minimeOneLetter]}
          />
        </FieldWrapper>
        <ButtonLogin
          background={COLORS.BLACK}
          handleClick={handleSubmit(handleClickSubmit)}
          loading={isLoading}
          color="#fff"><strong>Aceptar</strong>
        </ButtonLogin>
      </FormWrapper>
    </React.Fragment>
  )
};

const FormNewPasswordHoc = reduxForm({
  form: 'newPassword',
  initialValues: {
    password: ''
  }
})(Form);

export { FormNewPasswordHoc as FormNewPassword }
